import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { ConfigurationManagerService } from './core/services/configuration-manager.service';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { WINDOW_PROVIDERS } from './core/services/login.service';
import {
  BrowserModule,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorInterceptor } from './core/services/error-interceptor.service';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { provideBuildingModelAssets } from './core/providers/building-model-assets.providers';
export function initializeApp(
  configurationManager: ConfigurationManagerService
) {
  return () => configurationManager.load();
}
export const appConfig: ApplicationConfig = {
  //providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes)]
  providers: [
    ...provideBuildingModelAssets(),
    ConfigurationManagerService,
    WINDOW_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigurationManagerService],
      multi: true,
    },
    provideRouter(routes),

    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      NgxSpinnerModule.forRoot({ type: 'line-scale' }),
      ReactiveFormsModule
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([])
    ),
  ],
};
